import request from '../utils/request';
import { endpoint } from '../utils/config';

export async function postApplication(data) {
  const url = `${endpoint}/requests`;
  return await request({
    url,
    method: 'post',
    data
  });
}

export async function postApplicationComment(data) {
  console.log({ data })
  const url = `${endpoint}/requests/comment/${data?._id}`;
  return await request({
    url,
    method: 'post',
    data: { comment: data.comment }
  });
}

export async function getRequestStats(data){ 
  const url = `${endpoint}/requests/aggregateByStatus`;
  return await request({
    url,
    method: 'get',
    data
  });
}

export async function getOpenApplicationForms(data) {
  const url = `${endpoint}/requests/byStatus/open`;
  return await request({
    url,
    method: 'get',
    data
  });
}

export async function getMyApplicationForms({id, data}){ 
  const url = `${endpoint}/requests/byCreator/${id}`;
  return await request({
    url,
    method: 'get',
    data
  });
}

export async function getCloseApplicationForms(data) {
  const url = `${endpoint}/requests/byStatus/closed`;
  return await request({
    url,
    method: 'get',
    data
  });
}

export async function getAplicationById({ id }) {
  const url = `${endpoint}/requests/byId/${id}`;
  return await request({
    url,
    method: 'get'
  });
}

export async function putApprove({ id, data }) {
  const url = `${endpoint}/requests/approve/${id}`;
  return await request({
    url,
    method: 'put',
    data
  });
}

export async function putUnApprove({ id, data }) {
  const url = `${endpoint}/requests/unapprove/${id}`;
  return await request({
    url,
    method: 'put',
    data
  });
}

export async function putDecline({ id, data }) {
  const url = `${endpoint}/requests/decline/${id}`;
  return await request({
    url,
    method: 'put',
    data
  });
}

export async function putRequestChange({ id, data }) {
  const url = `${endpoint}/requests/requestChange/${id}`;
  return await request({
    url,
    method: 'put',
    data
  });
}
export async function putUnRequestChange({ id, data }) {
  const url = `${endpoint}/requests/unrequestChange/${id}`;
  return await request({
    url,
    method: 'put',
    data
  });
}

export async function getActivities(requestId){ 
  const url = `${endpoint}/activity/byRequest/${requestId}`;
  return await request({
    url,
    method: 'GET',
  });
}